var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 59,
    viewBox: "0 0 41 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 59,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_5834",
    transform: "scale(0.0243902 0.0169492)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_5834",
    width: 41,
    height: 59,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAA7CAYAAADmfqNmAAACSklEQVRoge2ZPWsiURRAjzsZBUGnECVWBkHExkawDAGZUqZOaTF/wM7CKn06wX9gLTb+BmEaCUExyKSKhGChYOEHs8XiQMK4unBlFd6p3oPLuwfue3fgTsjzPI8L59f/FjgFJSmFkpRCSUpxFZI3xwJ2ux2z2YyPjw/RxOl0mtvbWzRNOxp7UNLzPIbDIc/Pz0ynU1HBPdlslnq9TrFYJBQKHYwLHfosOo5Ds9lkuVyeRXBPLBbj6emJUql0MCbwTn59fdFut88uCLBcLmm1Wnx+fh6MCSz3y8sLo9HI31erVR4fH4nH4yJii8WCTqdDr9cDYDKZ8Pr6SiqVOl3y7e3NX+dyOWq1GslkUkQQwDAMarUao9GIyWTi53x4eAiMDyz3drv117quEw6HxQT3hMNhdF0PzPmTq+iTSlIKJSmFkpRCSUqhJKVQklIoSSmUpBRKUgolKYWSlEJM0nEcLMvCsiwcx5E6FhCSXK/X9Pt95vM58/mcfr/Per2WOBoQktQ0DcMw/L1hGCfNHU/l6BD1FDRNw7Zt8vk8APf395cnCRCJRDBNU+q4b1zv604kEv7adV3G47F44vF4jOu6gTl/EljuQqFANBpltVqxWq1oNBpkMhlubmRux3a75f393e8A0WiUQqHwb5L5fB7TNOl2u8CfFrMfdp4D0zT9RxdEYLl1Xce2bSqVytnE9lQqFWzb/jZQ/cnBvw8Am82GwWBAt9vFdV2xfznpdJq7uzssy6JcLv9V8KjkpXC9LejSUJJSKEkplKQUvwGxirg6MK8IuAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.4d6a6f5fee613a0f12698dea636560fa.svg";
export { ForwardRef as ReactComponent };